import { render, staticRenderFns } from "./PieceDetails.vue?vue&type=template&id=059b0330&scoped=true&"
import script from "./PieceDetails.vue?vue&type=script&lang=js&"
export * from "./PieceDetails.vue?vue&type=script&lang=js&"
import style0 from "./PieceDetails.vue?vue&type=style&index=0&id=059b0330&scoped=true&lang=css&"
import style1 from "./PieceDetails.vue?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/styles/tabs.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059b0330",
  null
  
)

export default component.exports